module.exports = __webpack_public_path__ + "static/media/news_3.64107da2.png";